import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import { sendGTMEvent } from 'reduxModules/googleTagManager/action';
import {
  COURSE_DETAIL_OVERVIEW_VIEW,
  COURSE_DETAIL_MATERIAL_VIEW,
  COURSE_DETAIL_DETAIL_VIEW,
  COURSE_DETAIL_INSTRUCTOR_VIEW,
  COURSE_DETAIL_FAQ_VIEW,
  COURSE_LESSONPAGE_KEYPOINTS_VIEW,
  COURSE_LESSONPAGE_SUMMARY_VIEW,
  COURSE_LESSONPAGE_MATERIAL_VIEW,
  COURSE_LESSONPAGE_INSTRUCTOR_VIEW,
  COURSE_LESSONPAGE_FAQ_VIEW,
} from 'constants/gtmEvent';

import {
  COURSE_OVERVIEW,
  COURSE_MATERIAL,
  COURSE_DETAIL,
  COURSE_INSTRUCTOR,
  COURSE_FAQ,
  LESSON_KEYPOINTS,
  LESSON_SUMMARY,
  LESSON_MATERIAL,
  LESSON_INSTRUCTOR,
  LESSON_FAQ,
  LESSON,
} from 'constants/courseTabKeys';

const EVENT_NAME = {
  [COURSE_OVERVIEW]: COURSE_DETAIL_OVERVIEW_VIEW,
  [COURSE_MATERIAL]: COURSE_DETAIL_MATERIAL_VIEW,
  [COURSE_DETAIL]: COURSE_DETAIL_DETAIL_VIEW,
  [COURSE_INSTRUCTOR]: COURSE_DETAIL_INSTRUCTOR_VIEW,
  [COURSE_FAQ]: COURSE_DETAIL_FAQ_VIEW,
  [LESSON_KEYPOINTS]: COURSE_LESSONPAGE_KEYPOINTS_VIEW,
  [LESSON_SUMMARY]: COURSE_LESSONPAGE_SUMMARY_VIEW,
  [LESSON_MATERIAL]: COURSE_LESSONPAGE_MATERIAL_VIEW,
  [LESSON_INSTRUCTOR]: COURSE_LESSONPAGE_INSTRUCTOR_VIEW,
  [LESSON_FAQ]: COURSE_LESSONPAGE_FAQ_VIEW,
};

const useTabSelected = ({
  init,
  courseEventTrackData,
  courseLessonEventTrackData,
}) => {
  const dispatch = useDispatch();
  const [tabSelected, setTabSelected] = useState(init);

  const eventTrackData = tabSelected.includes(LESSON)
    ? courseLessonEventTrackData
    : courseEventTrackData;

  useEffect(() => {
    setTabSelected(init);
  }, [init]);

  useEffect(() => {
    dispatch(
      sendGTMEvent({
        eventName: EVENT_NAME[tabSelected],
        data: {
          eventName: EVENT_NAME[tabSelected].toLowerCase(),
          ...eventTrackData,
        },
      }),
    );
  }, [dispatch, tabSelected, eventTrackData]);

  return [tabSelected, setTabSelected];
};

export default useTabSelected;
